import React, { useEffect, useState } from "react";

interface ZoomImageProps {
  images: { mdUrl?: string; xlUrl?: string; namespace: string }[];
}

const RandomImage: React.FC<ZoomImageProps> = ({ images }) => {
  const [randomImageUrl, setRandomImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (images.length === 1) {
      const url = images[0]?.xlUrl;
      if (url) {
        setRandomImageUrl(url);
      }
    }
    if (images.length > 0) {
      const randomIndex = Math.floor(Math.random() * images.length);
      const url = images[randomIndex]?.xlUrl;
      if (url) {
        setRandomImageUrl(url);
      }
    }
  }, []);

  return randomImageUrl ? (
    <img
      src={randomImageUrl}
      alt="Case Image"
      className="object-cover w-full h-full"
    />
  ) : null;
};

export default RandomImage;
